module.exports = __webpack_public_path__ + "img/title_3.566af1ee.png";